<script setup lang="ts">
import { CupraButton } from '@/components/cupra/button'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'

const emit = defineEmits(['retry'])
</script>

<template>
    <div class="mt-1.5 mb-3">
        <div class="bg-cupra-danger-dark-theme rounded p-4">
            <div class="flex gap-4">
                <ExclamationTriangleIcon class="size-6 text-white" />
                <p>
                    <slot />
                </p>
            </div>
        </div>

        <CupraButton
            @click="emit('retry')"
            class="mt-4"
            direction="back"
        >
            Probeer opnieuw
        </CupraButton>
    </div>
</template>
